import axios from "axios";
import { apiService } from "./api.service";
import { handleApiException, handleResponse } from "helpers/apiResponseHelper";
import { BankType, DocumentPayment, PaymentLocale, PaymentMethodType } from "models/payment";

interface BeginPaymentRequest {
  customerId: number;
  contactPersonId: number;
  documentPayments: DocumentPayment[];
  locale: PaymentLocale;
  paymentMethodType: PaymentMethodType;
  bankType?: BankType;
}

async function beginPayment(request: BeginPaymentRequest) {
  return axios.post(apiService.getApiUrl() + '/payment/' + request.customerId + '/begin', {...request})
    .then(handleResponse)
    .catch(handleApiException);
}

async function processPayment(token: string) {
  return axios.post(apiService.getApiUrl() + '/payment/process', {orderToken: token})
    .then(handleResponse)
    .catch(handleApiException);
}

async function getPaymentMethods() {
  return axios.get(apiService.getApiUrl() + '/payment/methods')
    .then(handleResponse)
    .catch(handleApiException);
}


const PaymentService = {
  beginPayment,
  processPayment,
  getPaymentMethods
};

export default PaymentService;